import { Component } from '@grafikr/components';
import fastdom from 'fastdom';

import { NonNullish } from '../utils/nullish-check';

export default Component((node) => {
  const HIDDEN_CLASS = 'header--hidden';
  let lastScrollPosition = window.scrollY;
  const announcementBar = document.querySelector<HTMLElement>('[data-announcement-bar]');

  let job: () => void;

  document.documentElement.style.setProperty('--header-height', `${node.offsetHeight}px`);
  document.documentElement.style.setProperty(
    '--header-inner-height',
    `${NonNullish(node.firstElementChild as HTMLElement).offsetHeight}px`,
  );
  document.documentElement.style.setProperty(
    '--announcement-bar-height',
    `${announcementBar?.offsetHeight || 0}px`,
  );

  const scrollEvent = () => {
    if (job) {
      fastdom.clear(job);
    }

    job = fastdom.mutate(() => {
      if (window.scrollY <= 100) {
        node.classList.remove(HIDDEN_CLASS);
        document.documentElement.style.setProperty(
          '--announcement-bar-height',
          `${announcementBar?.offsetHeight || 0}px`,
        );
      } else if (window.scrollY > lastScrollPosition) {
        node.classList.add(HIDDEN_CLASS);
        document.documentElement.style.setProperty('--announcement-bar-height', `0px`);
      } else {
        document.documentElement.style.setProperty('--announcement-bar-height', `0px`);
        node.classList.remove(HIDDEN_CLASS);
      }

      lastScrollPosition = window.scrollY;
    });
  };

  window.addEventListener('scroll', scrollEvent, {
    passive: true,
  });

  const triggers = node.querySelectorAll<HTMLElement>('[class*="group/menu"] > a');
  const megaMenus = node.querySelectorAll<HTMLElement>('[class*="group/menu"] .megamenu-content');
  let timeout: NodeJS.Timeout | null = null;
  const toggleClass = 'menu-active';

  const openGroup = (group: HTMLElement) => {
    closeAll();

    group.classList.add(toggleClass);
  };

  const closeGroup = (group: HTMLElement) => {
    group.classList.remove(toggleClass);
  };

  const closeAll = () => {
    triggers.forEach((trigger) => {
      NonNullish(trigger.parentElement).classList.remove(toggleClass);
    });
  };

  const debouncedOnMouse = (e: MouseEvent, type: string) => {
    if (!e) {
      return false;
    }

    const group: HTMLElement | null = (e?.target as HTMLElement)?.closest(
      '[class*="group/menu"]',
    );

    // clear old trigger
    clearTimeout(timeout as NodeJS.Timeout);

    // add new trigger
    timeout = setTimeout(() => {

      if (!group && type !== 'closeAll') return;

      switch (type) {
        case 'open':
          openGroup(group!);
          break;
        case 'close':
          closeGroup(group!);
          break;
        case 'closeAll':
          closeAll();
          break;
        default:
          break;
      }
    }, 200);
  };

  const mouseLeaveGroup = (e: MouseEvent) => debouncedOnMouse(e, 'close');
  const mouseEnterTarget = (e: MouseEvent) => debouncedOnMouse(e, 'open');
  const mouseLeaveContainer = (e: MouseEvent) => debouncedOnMouse(e, 'closeAll');

  triggers.forEach((trigger) => {
    trigger.addEventListener('mouseenter', mouseEnterTarget);
    NonNullish(trigger.parentElement).addEventListener('mouseleave', mouseLeaveGroup);
  });

  megaMenus.forEach((menu) => {
    menu.addEventListener('mouseleave', mouseLeaveGroup);
  });

  node.addEventListener('mouseleave', mouseLeaveContainer);
});
